import {
  styled,
  Card as MuiCard
} from '@material-ui/core';

export const Card = styled(MuiCard)(({ theme }) => ({
  border: `1px solid ${theme.palette.neutrals.high.medium}`,
  padding: theme.spacing(4),
  borderRadius: 8
}));